import { IntlShape } from "react-intl/lib";

export function getDashbaordExportButtonTitle(exportAction:boolean, intl:IntlShape){
    return exportAction ?
              intl.formatMessage({ id: 'Dashboard.Button.ExportToEmail.HoverTitle' }) :
              intl.formatMessage({ id: 'Dashboard.Button.ExportToEmail.HoverTitleNotAvailable' });
              
  }